import { baseNextjsUrl, isDev } from "@memorang/constants";

export const HUB_BASE_URL = "https://hub.memorang.com";

export const urls = {
	core: "https://memorang.com",
	dev: "http://localhost:8081",
};

export const API_BASE_URL = isDev
	? "https://beta.api.memorang.io"
	: "https://prod.api.memorang.io";

export const ENDPOINT_FEEDBACK = `${baseNextjsUrl}/api/ai/submissions`;
export const ENDPOINT_EXAM_CONTEXT = `${baseNextjsUrl}/api/ai/exam-context`;
export const ENDPOINT_HINT = `${baseNextjsUrl}/api/ai/hint`;
//TODO:Update this endpoint to the new one
export const ENDPOINT_GENERATE_EXPLANATION =
	"https://next-api-endpoints-acme.vercel.app/api/evaluator";
export const ENDPOINT_GET_ATTRIBUTE_STATS =
	"https://next-api-endpoints-acme.vercel.app/api/get-attribute-stats";

export const ENDPOINT_GENERATE_EXPLANATION_FOR_RECORDING = `${baseNextjsUrl}/api/ai/generate-explanation`;
export const ENDPOINT_TTS_MP3 = `${baseNextjsUrl}/api/ai/tts-mp3`;
export const ENDPOINT_ASSESSOR = `${baseNextjsUrl}/api/ai/graphs/assessor`;
export const TTS_BUCKET = "memorang-assets/partners/toefl/tts-audio";
export const ENDPOINT_DEMO_EMR_ANALYSIS =
	"https://staging-hub.memorang.com/api/ai/demo";

export const ENDPOINT_DIAGNOSTIC = `${baseNextjsUrl}/api/diagnostic`;
export const ENDPOINT_DIAGNOSTIC_RESPONSE = `${baseNextjsUrl}/api/diagnostic/response`;

// TODO: everything should use hub.memorang.com eventually
export const ENDPOINT_TRANSCRIPT = "https://hub.memorang.com/api/transcript";
export const ENDPOINT_PROETHICS_TURN =
	"https://hub.memorang.com/api/proethics/turn";
export const ENDPOINT_PROETHICS_SUMMATIVE =
	"https://hub.memorang.com/api/proethics/summative";
export const ENDPOINT_APP_CONFIG = (buildType: string) =>
	`${HUB_BASE_URL}/api/app-config/${buildType}`;
